var render = function render(){var _vm=this,_c=_vm._self._c;return _c('box-panel',{attrs:{"title":_vm.$t('home_v3.trends_insights'),"items":_vm.trends}})
}
var staticRenderFns = []

export { render, staticRenderFns }